module.exports = __webpack_public_path__ + "static/media/deep-shikha.d18539fc.jpeg";